import { isEmpty, clone } from 'lodash';
import { getPathNodeDatas } from '@/utils/tree';

const DEFAULT_TREETYPE = 'instance';

export default {
  data() {
    return {
      treeRef: 'apmTree',
      treeData: null,
      /**
       * 찾는 노드가 없을 때 데이터 재조회 여부
       * 기본은 false이며, 데이터를 재조회하지 않은 상태.
       * true일 경우 이미 특정 트리 키의 노드가 없어 데이터를 한 상태이다.
       * @type {Boolean}
       */
      reload: false,
      reloadable: false,
      redirect: false,
    };
  },
  computed: {
    /**
     * 선택된 메뉴
     * @author Ju
     * @return {String} 선택된 메뉴의 아이디
     */
    selectedMenu() {
      return this.$store.getters.selectedMenu;
    },
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    treeType() {
      return this.$store.state.apm.treeType;
    },
  },
  watch: {
    /**
     * 최초 url호출 시 treeType 저장
     * route에서 treeKey이 변경이 감지되면 변경된 treeKey의 노드가 선택되도록 한다.
     * @type {Object}
     */
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (!isEmpty(this.treeData)) {
          this.handlerForRouter(to, from);
        } else if (this.reloadable) {
          const treeKey = to.params.treeKey;
          if (treeKey !== null) {
            this.loadData(treeKey).then(() => {
              this.handlerForRouter(to, from);
            });
          }
        } else {
          // const treeType = isEmpty(to.params.treeType) ? DEFAULT_TREETYPE : to.params.treeType;
          this.setStoreData(null, null, DEFAULT_TREETYPE);
        }
      },
    },
    treeData() {
      const routeTreeKey = this.$route.params.treeKey;
      if (!isEmpty(routeTreeKey)) {
        this.$nextTick(() => {
          const params = {
            path: this.$route.path,
            params: this.$route.params,
          };

          const node = this.$refs[this.treeRef].getNode(routeTreeKey);
          if (!this.isValidNode(node)) {
            this.routeByTreeKey(this.treeRef, this.getDefaultTreeKey(), true);
          } else {
            this.setSelectedNode(routeTreeKey);
            this.$router.replace(params);
          }
        });
      }
    },
  },
  methods: {
    handlerForRouter(to, from) {
      this.$store.dispatch('setSelectedTreeKey', to.params.treeKey);
      if (isEmpty(from)) {
        this.$nextTick(() => {
          this.setSelectedNode(to.params.treeKey);
          this.$router.replace({
            path: this.$route.path,
            params: this.$route.params,
          });
        });
      } else if (to.params.treeKey !== from.params.treeKey) {
        this.$nextTick(() => {
          this.setSelectedNode(to.params.treeKey);
        });
      }
    },
    /**
     * 트리 타입 또는 노드로 라우팅 한다.
     * @param  {[type]} reference    [description]
     * @param  {[type]} treeKey      [description]
     * @param  {[type]} redirectFlag [description]
     * @return {[type]}              [description]
     * @author jda
     */
    routeByTreeKey(reference, treeKey, redirectFlag) {
      const treeType = this.treeType;
      const location = {
        path: `/${this.selectedMenu.url}/${treeType}/${treeKey}`,
        params: { treeType, treeKey },
      };

      if (redirectFlag) {
        this.$router.replace(location);
      } else {
        this.$router.push(location);
      }
    },
    /**
     * treeKey에 대한 노드가 선택되도록 설정한다.
     * 1) currentKey 설정 및 노드의 path 기준으로 expand.
     * 2) common store의 selectedNode와 selectedNodePath 설정
     * @author Ju
     */
    setSelectedNode(treeKey) {
      const node = this.$refs[this.treeRef].getNode(treeKey);
      if ((isEmpty(node) || !this.isValidNode(node)) && !isEmpty(this.treeData)) {
        if (this.reloadable === true && this.reload === false) {
          this.reload = true;
          this.loadData().then(() => {
            this.setSelectedNode(treeKey);
          });
        } else if (this.redirect === false) {
          this.redirect = true;
          this.routeByTreeKey(this.treeRef, this.getDefaultTreeKey(), true); // 트리 키에 해당하는 노드가 없을 경우 local로 redirect
        }
      } else {
        this.reload = false;
        this.redirect = false;

        let nodeData;
        let nodePath;
        if (isEmpty(node)) {
          nodeData = null;
        } else {
          nodeData = clone(node.data);
          nodePath = clone(getPathNodeDatas(node));
          if (node.parent.data.type === 'group') {
            nodeData.parent = node.parent.data;
          }
          this.$refs[this.treeRef].setCurrentKey(treeKey);
        }

        this.setStoreData(nodeData, nodePath, this.treeType);
      }
    },
    setStoreData(nodeData, nodePath, treeType) {
      this.$store.dispatch('setSelectedNode', nodeData);
      this.$store.dispatch('setSelectedNodePath', nodePath);
      this.$store.dispatch('setTreeType', treeType);
    },
    /**
     * 유효한 노드인지 확인한다.
     * true면 유효한 노드, false는 유효하지 않는 노드(라우트 불가)이다.
     * 기본적으로 빈 노드가 아니면 true를 반환한다.
     * 트리마다 선택될 수 있는 노드 기준이 다르므로 필요 시 override 한다.
     * @author Ju
     * @param  {[type]}  node [description]
     * @return {Boolean}      [description]
     */
    isValidNode(node) {
      return !isEmpty(node);
    },
    /**
     * 기본으로 선택될 노드의 treeKey를 반환한다.
     * 기본적으로 rootNode는 첫번째 도메인이 된다.
     * 도메인이 없을 경우 null 반환.
     * @return {[type]} [description]
     * @author jda
     */
    getDefaultTreeKey() {
      if (isEmpty(this.treeData)) {
        return 1;
      }
      return this.treeData[0].treeKey;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/apm/tree-router.js